import { useEffect, useState } from "react";
import apiClient from "../../../components/utils/apiClient";
import RequestsTable from "../../../components/requests/RequestsTable";

const SingleTabRequests = ({workerId,setIsActionLoading}) => {

    const [requests, setRequests] = useState(null);

    const getRequests = async () => {
        try {
          const response = await apiClient.get(`/requests?skip=0&workerId=${workerId}`);
          if(response?.data) {
            setRequests(response?.data);
          } else {

          }
          setIsActionLoading(false);
        } catch(err) {setIsActionLoading(false);}
    }

    useEffect(()=>{
        setIsActionLoading(true);
        getRequests();
    },[])


    return (
        <>
        <div className="w-full overflow-x-auto">
          <RequestsTable requests={requests} />
        </div>
        </>);
}
export default SingleTabRequests;